// AC #2: confidence is shown as a TEXT label only — never a numeric score.
// null means render no label at all (no score available).
export function confidenceLabel(confidence: number | null | undefined): string | null {
	if (confidence == null) return null;
	return confidence >= 0.75 ? 'High confidence' : 'Medium confidence';
}
